import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-gray-333 personal-flow-settings-container" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = { class: "personal-flow-table" }
const _hoisted_5 = { class: "text-center flex items-center justify-center" }
const _hoisted_6 = { class: "text-center flex items-center justify-center" }
const _hoisted_7 = { class: "text-center flex items-center justify-center" }
const _hoisted_8 = { class: "text-center flex items-center justify-center" }
const _hoisted_9 = { class: "text-center flex items-center justify-center" }
const _hoisted_10 = { class: "text-center flex items-center justify-center" }
const _hoisted_11 = { class: "text-center flex items-center justify-center" }
const _hoisted_12 = { class: "text-center flex items-center justify-center" }
const _hoisted_13 = { class: "text-center flex items-center justify-center" }
const _hoisted_14 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")
  const _component_Table = _resolveComponent("Table")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.t('approvedPersonFlowNote')) + " ", 1),
      _hoisted_3
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Table, {
        class: "text-center",
        headers: _ctx.personFlowHeaders,
        data: _ctx.approveFlowListData,
        showPagination: true,
        recordTotal: _ctx.pagination.total,
        itemsPerPages: _ctx.pagination.per_page,
        currentPage: _ctx.paramsUnit.page,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_ctx.paramsUnit.page = $event)),
        onOnChangePage: _ctx.onChangePage
      }, {
        work_record_application: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_5, [
            _createVNode("span", {
              class: ["mr-2", 
                item.application_flows[0].is_basic_flow === false
                  ? 'round-personal'
                  : null
              ]
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.handleItemIsBasic(item.application_flows[0].is_basic_flow)), 1)
          ])
        ]),
        work_schedule_change_application: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_6, [
            _createVNode("span", {
              class: ["mr-2", 
                item.application_flows[1].is_basic_flow === false
                  ? 'round-personal'
                  : null
              ]
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.handleItemIsBasic(item.application_flows[1].is_basic_flow)), 1)
          ])
        ]),
        vacation_request: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_7, [
            _createVNode("span", {
              class: ["mr-2", 
                item.application_flows[2].is_basic_flow === false
                  ? 'round-personal'
                  : null
              ]
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.handleItemIsBasic(item.application_flows[2].is_basic_flow)), 1)
          ])
        ]),
        transfer_attendance: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_8, [
            _createVNode("span", {
              class: ["mr-2", 
                item.application_flows[3].is_basic_flow === false
                  ? 'round-personal'
                  : null
              ]
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.handleItemIsBasic(item.application_flows[3].is_basic_flow)), 1)
          ])
        ]),
        holiday_commuting_application: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_9, [
            _createVNode("span", {
              class: ["mr-2", 
                item.application_flows[4].is_basic_flow === false
                  ? 'round-personal'
                  : null
              ]
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.handleItemIsBasic(item.application_flows[4].is_basic_flow)), 1)
          ])
        ]),
        substitute_leave_application: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_10, [
            _createVNode("span", {
              class: ["mr-2", 
                item.application_flows[5].is_basic_flow === false
                  ? 'round-personal'
                  : null
              ]
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.handleItemIsBasic(item.application_flows[5].is_basic_flow)), 1)
          ])
        ]),
        leave_application: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_11, [
            _createVNode("span", {
              class: ["mr-2", 
                item.application_flows[6].is_basic_flow === false
                  ? 'round-personal'
                  : null
              ]
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.handleItemIsBasic(item.application_flows[6].is_basic_flow)), 1)
          ])
        ]),
        absence_application: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_12, [
            _createVNode("span", {
              class: ["mr-2", 
                item.application_flows[7].is_basic_flow === false
                  ? 'round-personal'
                  : null
              ]
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.handleItemIsBasic(item.application_flows[7].is_basic_flow)), 1)
          ])
        ]),
        waiting_allowance_application: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_13, [
            _createVNode("span", {
              class: ["mr-2", 
                item.application_flows[8].is_basic_flow === false
                  ? 'round-personal'
                  : null
              ]
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(_ctx.handleItemIsBasic(item.application_flows[8].is_basic_flow)), 1)
          ])
        ]),
        edit: _withCtx(({ item }) => [
          _withDirectives(_createVNode("div", {
            onClick: ($event: any) => (_ctx.editPersonalFlowSettings(item))
          }, [
            _createVNode("div", _hoisted_14, [
              _createVNode(_component_BaseIcon, {
                name: "pencil-line",
                class: "cursor-pointer"
              })
            ])
          ], 8, ["onClick"]), [
            [_directive_tooltip, _ctx.t('actionEdit')]
          ])
        ]),
        _: 1
      }, 8, ["headers", "data", "recordTotal", "itemsPerPages", "currentPage", "onOnChangePage"])
    ])
  ]))
}